<template>
	<div :class="['marketing-input-container', containerClass]">
		<label :class="['marketing-label', labelClass]">
			{{ label }}
		</label>
		<input class="marketing-input" v-bind="$attrs" :value="modelValue" @input="onChange" />
	</div>
</template>

<script>
	export default {
		name: 'MarketingInput',
		props: ['label', 'labelClass', 'containerClass', 'modelValue'],
		methods: {
			onChange(event) {
				const value =
					this.$attrs.type === 'number'
						? parseFloat(parseFloat(event.target.value).toFixed(2)) || 0
						: event.target.value;
				this.$emit('update:modelValue', value);
			},
		},
	};
</script>

<style lang="scss" scoped>
	.marketing-input-container {
		@apply flex items-center mr-3 mb-2 h-9;

		.marketing-label {
			@apply text-13 font-semibold mr-2;
			min-width: 36px;
		}

		.marketing-input {
			@apply border-1 border-border-color rounded-default bg-white py-1 px-2 h-9;
			outline: none;
			&:disabled {
				@apply cursor-not-allowed;
			}
		}
	}
</style>
